var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CreateInstance,{attrs:{"loading-message":_setup.loadingTemplatesInfoMessage,"loading":_setup.loading,"prefix":"object-store"}},[_c(_setup.SelectTemplate,{attrs:{"templates":_setup.templates},on:{"onSubmit":_setup.chooseTemplate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }